import { OnboardingItemKey } from "../../../common/enums";
import { IOnboardingFlow } from "./onboardingTypes";
import { buildFlow } from "./allSteps";

// Steps for Employee_Instructor and Employee_Instructor_Group_Events roles.
const instructorStepIds: OnboardingItemKey[] = [
  OnboardingItemKey.GetToKnowPlanny,
  OnboardingItemKey.CreateEvent,
  OnboardingItemKey.EventWizard,
  OnboardingItemKey.EventWizardHybrid,
  OnboardingItemKey.ServiceWizardGuide,
  OnboardingItemKey.BlockedTimeGuide,
  OnboardingItemKey.FirstUser,
  OnboardingItemKey.UserAdd,
  OnboardingItemKey.UserProfile,
  OnboardingItemKey.DashboardKpis,
  OnboardingItemKey.Statistics,
  OnboardingItemKey.StatisticsDetail,
  OnboardingItemKey.Support,
  // Page Guides (hidden, component-driven)
  OnboardingItemKey.RefillCardGuide,
  OnboardingItemKey.RefillCardEmpty,
  OnboardingItemKey.InventoryGuide,
  OnboardingItemKey.InventoryOverviewGuide,
  OnboardingItemKey.InventoryTransfersGuide,
  OnboardingItemKey.CashdeskGuide,
  OnboardingItemKey.CashdeskEmpty,
  OnboardingItemKey.FamiliesGuide,
  OnboardingItemKey.BreakTypesGuide,
  OnboardingItemKey.GymVisitsGuide,
];

export const instructorFlow: IOnboardingFlow = buildFlow(instructorStepIds);
